export const breakpoints = {
  LARGE: 979,
  MID: 768,
  SMALL: 480
};

export const FRONTEND =
  process.env.NODE_ENV === "production"
    ? "/static/nestseekers/"
    : "http://localhost:3000/";


export const CORS_ANYWHERE = "https://d1ck45hpd36lhm.cloudfront.net/"